import { CommonAction, ICommonState, ReduxCommonActionType } from './model';
import { CommonInitState } from './state';

export const commonReducer = (
  state = CommonInitState,
  action: CommonAction
): ICommonState => {
  switch (action.type) {
    case ReduxCommonActionType.LOGIN:
      return { ...state, userInfo: action.result };
    case ReduxCommonActionType.LOGOUT:
      return { ...state, userInfo: null };
    case ReduxCommonActionType.SELECT_MENU_ID:
      return { ...state, selectMenuId: action.result };
    case ReduxCommonActionType.STUDIO_INFO:
      return {
        ...state,
        studioInfo: action.result,
      };
    default:
      return state;
  }
};
